import * as React from 'react';
const classNames = require('classnames');

import Label from './Label';
import { IconCheck } from '../icons';

interface Props {
	name: string;
	labelText?: {};
	onChildren: string;
	offChildren: string;
	checked?: boolean;
	value?: string;
	onBlur?: (value: {}) => void;
	onChange?: (value?: {}) => void;
	className?: string;
	controlClassName?: string;
	disabled?: boolean;
	id?: string;
	conditionalChildren?: {};
}
const ToggleSwitch: React.StatelessComponent<Props> = props => {
	return (
		<div className={classNames('form-group toggle-switch', props.className, { disabled: props.disabled })}>
			{props.labelText && <Label>{props.labelText}</Label>}
			<div className="input-group">
				<div className="toggle-switch-button">
					<input
						className="toggle-switch-radio"
						type="radio"
						id={(props.id || props.name) + 'On'}
						name={props.name}
						value={'true'}
						onBlur={props.onBlur}
						onChange={props.onChange}
						checked={props.checked === true}
						disabled={props.disabled}
					/>
					<label
						className={classNames(
							'toggle-switch-label toggle-left',
							props.checked === true ? 'toggle-on' : 'toggle-off'
						)}
						htmlFor={(props.id || props.name) + 'On'}
					>
						<span className="toggle-switch-text align-middle">{props.onChildren}</span>
						<IconCheck className="toggle-switch-icon ml-2" />
					</label>
				</div>
				<div className="toggle-switch-button">
					<input
						className="toggle-switch-radio"
						type="radio"
						id={(props.id || props.name) + 'Off'}
						name={props.name}
						value={'false'}
						onBlur={props.onBlur}
						onChange={props.onChange}
						checked={props.checked === false}
						disabled={props.disabled}
					/>
					<label
						className={classNames(
							'toggle-switch-label toggle-right',
							props.checked === false ? 'toggle-on' : 'toggle-off'
						)}
						htmlFor={(props.id || props.name) + 'Off'}
					>
						<span className="toggle-switch-text align-middle">{props.offChildren}</span>
						<IconCheck className="toggle-switch-icon ml-2" />
					</label>
				</div>
			</div>
			{props.conditionalChildren}
		</div>
	);
};

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/ToggleSwitch.tsx